import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=1b0fc798&scoped=true&"
import script from "./svg-icon.vue?vue&type=script&lang=js&"
export * from "./svg-icon.vue?vue&type=script&lang=js&"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=1b0fc798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0fc798",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0fc798')) {
      api.createRecord('1b0fc798', component.options)
    } else {
      api.reload('1b0fc798', component.options)
    }
    module.hot.accept("./svg-icon.vue?vue&type=template&id=1b0fc798&scoped=true&", function () {
      api.rerender('1b0fc798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/videoTrial/demo/components/common/svg-icon.vue"
export default component.exports